import Vue from 'vue';
import ImageKit from '@/libs/imagekit';

if (!process.env.VUE_APP_IMAGE_KIT_UPLOAD_FOLDER) {
  throw new Error('VUE_APP_IMAGE_KIT_UPLOAD_FOLDER is not set');
}
if (!process.env.VUE_APP_IMAGE_KIT_PUBLIC_KEY) {
  throw new Error('VUE_APP_IMAGE_KIT_PUBLIC_KEY is not set');
}
if (!process.env.VUE_APP_IMAGE_KIT_URL) {
  throw new Error('VUE_APP_IMAGE_KIT_URL is not set');
}
if (!process.env.VUE_APP_IMAGE_KIT_AUTHEN_URL) {
  throw new Error('VUE_APP_IMAGE_KIT_AUTHEN_URL is not set');
}

const ik = new ImageKit({
  publicKey: process.env.VUE_APP_IMAGE_KIT_PUBLIC_KEY,
  privateKey: process.env.VUE_APP_IMAGE_KIT_PRIVATE_KEY,
  urlEndpoint: process.env.VUE_APP_IMAGE_KIT_URL,
  authenticationEndpoint: process.env.VUE_APP_IMAGE_KIT_AUTHEN_URL,
});

const helpers = {
  imagekit: ik,
  upload: ({
    file,
    fileName,
    tags,
  }) => {
    const params = {
      file,
      fileName,
      useUniqueFileName: true,
      isPrivateFile: false,
      folder: process.env.VUE_APP_IMAGE_KIT_UPLOAD_FOLDER,
      tags: tags || [],
    };

    return new Promise((res, rej) => {
      ik.upload(params, (err, result) => {
        if (err) rej(err);
        else res(result);
      });
    });
  },
};

export default {
  install() {
    Vue.imagekit = helpers;
    Vue.prototype.$imagekit = helpers;
  },
};
